





































































































































































































































import { Component, Mixins } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AccountModule from '@/store/modules/Account';
import GeneralModule from '@/store/modules/General';
import AuthModule from '@/store/modules/Auth';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import ManageMixin from '@/mixins/Manage.vue';
import UserData from '@/data/User';

@Component
export default class EditAgentView extends Mixins(ErrorHandleMixin, ManageMixin) {
  AccountInstance = getModule(AccountModule, this.$store);

  GeneralInstance = getModule(GeneralModule, this.$store);

  AuthInstance = getModule(AuthModule, this.$store);

  mainKey = 0;

  selected: any = {};

  isSuperadmin = false;

  isAllowResetPassword = false;

  beforeMount() {
    const { id } = this.$router.currentRoute.params;
    if (!id) this.$router.go(-1);
  }

  async created() {
    const { id } = this.$router.currentRoute.params;
    this.selected = this.AccountInstance.users.users.find((item) => item._id === id);
    if (this.AuthInstance.user.userPermission.member === 'edit') {
      if (['SUBAGENT', 'SUBACCOUNT'].includes(this.AuthInstance.user.role) && this.selected.level === this.AuthInstance.user.level) this.isAllowResetPassword = true;
      if (['AGENT'].includes(this.AuthInstance.user.role) && (this.selected.level - 1) === this.AuthInstance.user.level) this.isAllowResetPassword = true;
    }
    this.selected.role = 'MEMBER';
    this.isSuperadmin = ['SUPERADMIN'].includes(this.AuthInstance.user.role);
  }

  alert(res) {
    const { code } = res;
    if (code === 0) {
      this.modalData = {
        profile: UserData.initialUserInfo(),
        lock: UserData.initialLock(),
        password: UserData.initialPassword(),
        pt: UserData.initialPT(),
        refill: UserData.initialRefill(),
        deduct: UserData.initialDeduct(),
      };
    }
    this.modal = UserData.initialModal();
    this.checkError(res);
  }
}
